import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { taxApi } from "../../../assets/apis";
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import Spinner from "../../../spinner/first_spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  setSiderBarActiveLink,
  setSiderBarActiveList,
} from "../../../redux-store/sidebarActiveList";
import CoverSpin from "../../../spinner/second_spinner/CoverSpin";
import SecondSpinner from "../../../spinner/third_spinner/SecondSpinner";
import NotFoundWithImage from "../../../notFound/NotFoundWithImage/NotFoundWithImage";

const EditTax = () => {
  const { FYear } = useSelector((store) => store.FinancialYear);
  const dispatch = useDispatch();
  const [editedTaxData, setEditedTaxData] = useState({ active: true });
  const navigate = useNavigate();
  const { id } = useParams();

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditedTaxData((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleInputChangeWithCondition = (e, validationRegex) => {
    const { name, value } = e.target;
    if (value === "" || validationRegex.test(value)) {
      setEditedTaxData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleInputChangeWithConditonTypeNumber = (e, validationRegex) => {
    const { name, value } = e.target;
    if (value === "" || validationRegex.test(value)) {
      setEditedTaxData((prev) => ({ ...prev, [name]: Number(value) }));
    }
  };

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data) => {
      return axios.put(`${taxApi}/${id}`, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["category"]);
      toast.success("tax saved successfully!");
      navigate("/tax");
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message;
      toast.error(` ${errorMessage}`);
    },
  });

  const handleSaveTax = (e) => {
    e.preventDefault();
    const { name, rate, description } = editedTaxData;
    const updatedTaxData = {
      ...editedTaxData,
      name: name.trim(),
      ...(description && { description: description.trim() }),
    };

    setEditedTaxData(updatedTaxData);
    if (!updatedTaxData.name) return toast.error("Please enter a name");
    if (+rate > 100) return toast.error("Please enter a valid rate");
    mutation.mutate(updatedTaxData);
  };

  const { data, isError, isLoading, error, isFetching } = useQuery({
    queryKey: [id, FYear.value],
    queryFn: () =>
      axios.get(`${taxApi}/${id}`).then((response) => response.data.data),
    retry: false,
  });

  useEffect(() => {
    if (data) {
      const { createdAt, updatedAt, companyId, id, ...rest } = data;
      setEditedTaxData(rest);
    }
  }, [data]);

  useEffect(() => {
    dispatch(setSiderBarActiveList({ name: "Taxes" }));
    dispatch(setSiderBarActiveLink({ link: "tax" }));
  }, []);

  if (isLoading || isFetching) {
    return (
      <div className="main-panel">
        <div className="content-wrapper">
          <SecondSpinner />
        </div>
      </div>
    );
  }

  if (isError) return <NotFoundWithImage />;

  return (
    <div className={`main-panel`}>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-sm-12">
            <div className="d-flex justify-content-between m-1 p-1 align-items-baseline ">
              <h3 className="ukhd mb-3">Edit Tax</h3>
              <button
                type="button"
                className="btn btn-warning btn-sm"
                onClick={() => navigate("/tax")}
              >
                <div className="d-flex justify-content-center">
                  <i className="mdi mdi mdi-keyboard-backspace"></i>
                  <span>Back</span>
                </div>
              </button>
            </div>
            <div className="row flex-grow">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card card-rounded">
                  <div className="card-body">
                    <div className="col-lg-12">
                      <div className="col-lg-12 ">
                        <h5>TAX INFORMATION</h5>
                      </div>
                      <form onSubmit={handleSaveTax}>
                        <div className="row">
                          <div className="col-lg-4 mt-4">
                            <label>Name *</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Tax"
                              name="name"
                              required
                              value={editedTaxData.name || ""}
                              onChange={(e) => {
                                handleInputChangeWithCondition(e, /^[\s\S]*$/);
                              }}
                            />
                          </div>
                          <div className="col-lg-4 mt-4">
                            <label>Tax (%) *</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Percentage"
                              name="rate"
                              required
                              value={editedTaxData.rate || ""}
                              onChange={(e) =>
                                handleInputChangeWithConditonTypeNumber(
                                  e,
                                  /^[0-9\b]+$/
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 mt-4">
                          <label>Active ? </label>{" "}
                          <input
                            type="checkbox"
                            name="active"
                            checked={editedTaxData.active || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-lg-9 mt-4">
                          <label
                            className="form-control-label"
                            htmlFor="input-address"
                          >
                            Description
                          </label>
                          <textarea
                            className="form-control form-control-alternative"
                            rows="7"
                            style={{
                              borderRadius: "5px",
                              resize: "none",
                              minHeight: "80px",
                            }}
                            name="description"
                            value={editedTaxData.description || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-lg-9 mt-2">
                          <button
                            type="submit"
                            className="btn btn-primary d-flex justify-content-center px-3 py-2"
                          >
                            <i className="mdi mdi-content-save me-1"></i> Save
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTax;
